import React from 'react';

import { useCreateFile } from '@vlabs/api/point-api/client';
import { PlusIcon } from '@vlabs/icons';
import { useModal } from '@vlabs/uikit';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button/IconButton.js';
import type { IconButtonProps } from '@vlabs/uikit/components/controls/button/icon-button/IconButton.js';

import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { AddCardFileForm } from './AddCardFileForm';
import type { AddCardFileProps } from './types';

type AddCardFileIconButtonProps = AddCardFileProps & IconButtonProps;

const displayName = 'AddCardFileIconButton';
const testid = buildTestid(displayName);

function AddCardFileIconButton({
  cardId,
  onAddCardFile = undefined,
  'data-testid': dataTestId = undefined,
  ...props
}: AddCardFileIconButtonProps): JSX.Element {
  const modal = useModal();
  const createFile = useCreateFile({
    mutation: {
      onSuccess: (createdFile) => {
        onAddCardFile?.(createdFile);
        modal.close();
      },
    },
  });

  return (
    <React.Fragment>
      {modal.wrap(<AddCardFileForm
        onCancel={modal.close}
        onSubmit={({ file, filename }) => {
          createFile.mutate({
            data: file.item(0) as File,
            params: {
              card_id: cardId,
              filename,
              mimetype: (file.item(0) as File).type,
            },
          });
        }}
      />)}

      <IconButton
        icon={<PlusIcon />}
        kind="secondary"
        onClick={modal.open}
        variant="filled"
        {...testid(dataTestId)}
        {...props}
      />
    </React.Fragment>
  );
}

AddCardFileIconButton.displayName = displayName;

export { AddCardFileIconButton };
